import { StablesOperationPage } from "./StablesOperationPage";

export const StablesComprar = () => (
  <StablesOperationPage
    operation="buy"
    title="Comprar stablecoins"
    subTitle="Converta reais em USDC ou USDT. Acompanhe suas compras no histórico abaixo."
    historyType="purchases"
    historyTitle="Histórico de compras"
  />
);
